(() => {
  document.querySelectorAll('[data-star-photo-trigger]').forEach(trigger => {
    const dialog = document.getElementById(trigger.dataset.starPhotoTrigger);
    if (!dialog || trigger.dataset.photoReady) return;
    trigger.dataset.photoReady = 'true';
    trigger.addEventListener('click', () => dialog.showModal());
    dialog.querySelector('.mi-jose-photo-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
  });
})();
